import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 bg-cream">
      <h1 className="font-serif font-bold text-[8rem] md:text-[12rem] text-champagne/20 select-none leading-none">
        404
      </h1>
      <div className="relative z-10 -mt-12 md:-mt-16">
        <h2 className="text-graphite mb-4">頁面不存在</h2>
        <p className="text-medium-gray text-base mb-2">您訪問的頁面可能已被移除或網址有誤</p>
        <p className="text-light-gray text-base font-mono mb-8">{location.pathname}</p>
        <Link to="/" className="btn-dark">
          返回首頁
        </Link>
      </div>
    </div>
  );
}